'use client';

import { usePageAction } from '@repo/hooks/usePageAction';
import { useShallow } from 'zustand/shallow';
import { INITIAL_DEPOSIT_INPUT_PATTERN } from '../../constants';
import { CurrencyCalculatorInput } from '../../shared/CurrencyCalculatorInput';
import { useHYSACalculatorStore } from './calculatorStore';
import { formatToDisplayValue } from './utils';

export function InitialDepositForm() {
  const fireHysaCalculatorInteractedPageAction = usePageAction({
    actionName: 'hysa_calculator_interacted',
    actionSection: 'banking',
    actionType: 'select',
  });
  const {
    annualPercentageYield,
    initialDeposit,
    initialDepositError,
    monthlyDeposit,
    setField,
    timePeriod,
  } = useHYSACalculatorStore(
    useShallow(state => ({
      annualPercentageYield: state.formFields.annualPercentageYield,
      initialDeposit: state.formFields.initialDeposit.includes(',')
        ? state.formFields.initialDeposit
        : formatToDisplayValue(state.formFields.initialDeposit),
      initialDepositError: state.errors.initialDeposit,
      monthlyDeposit: state.formFields.monthlyDeposit.includes(',')
        ? state.formFields.monthlyDeposit.replace(/,/g, '')
        : formatToDisplayValue(state.formFields.monthlyDeposit),
      timePeriod: state.formFields.timePeriod,
      setField: state.setField,
    })),
  );

  return (
    <CurrencyCalculatorInput
      error={initialDepositError}
      id="initial-deposit"
      label="Initial deposit"
      pattern={INITIAL_DEPOSIT_INPUT_PATTERN}
      value={initialDeposit}
      onValidRawChange={raw => {
        fireHysaCalculatorInteractedPageAction({
          additional_attributes: {
            annual_percentage_yield_value_input: annualPercentageYield,
            initial_deposit_value_input: raw,
            monthly_deposit_value_input: monthlyDeposit,
            time_period_value_input: timePeriod,
          },
        });
        setField('initialDeposit', raw);
      }}
    />
  );
}
